<template>
    <div class="signature-pad-wrapper">
        <span class="cleaner" v-on:click="clear">
            <span class="material-icons-outlined">
                refresh
            </span>
        </span>
        <canvas ref="canvas" height="375" width="830" class="signature-pad"></canvas>
    </div>
</template>

<script>
import SignaturePad from 'signature_pad'

export default {
    data(){
        return{
            instance:null,
            clicked:false
        }
    },
    mounted(){
        this.createInstance()
    },
    updated(){
        this.createInstance()
    },
    methods:{
        createInstance(){
            if(this.instance == null){
                this.instance = new SignaturePad(this.$refs.canvas)
                window.addEventListener("resize", this.resizeCanvas)
                this.resizeCanvas()
                this.configureColor()
            }
        },
        resizeCanvas() {
            if(this.$refs.canvas){
                const ratio = Math.max(window.devicePixelRatio || 1, 1)
                this.$refs.canvas.width = this.$refs.canvas.offsetWidth * ratio
                this.$refs.canvas.height = this.$refs.canvas.offsetHeight * ratio
                this.$refs.canvas.getContext("2d").scale(ratio, ratio)
                this.instance.clear()
            }
        },
        configureColor(){
            this.instance.penColor = "rgb(0, 0, 0)";
        },
        clear(){
            this.instance && this.instance.clear()  
        },
        get(){
            if(!this.instance.isEmpty()){
                return {
                    PNG: this.instance.toDataURL(),
                    JPEG: this.instance.toDataURL("image/jpeg"),
                    SVG: this.instance.toSVG("image/jpeg"),
                    SVGXML: this.instance.toDataURL("image/svg+xml"),
                    Data: this.instance.toData()
                }
            }else return null
        },
    },
}
</script>

<style>
.signature-pad-wrapper{
    position: relative;
    width: 100%;
    max-width: 830px;
    aspect-ratio: 830/375;
    padding: 0.5rem;
    border-radius: 0.375rem;
    background-color: hsla(252, 24%, 95%,0.25) ;
    border: 3px solid hsl(252, 24%, 95%) ;
}

.signature-pad-wrapper canvas{
    height: 100%;
    width: 100%;
    border-radius: calc(0.375rem );
}

.signature-pad-wrapper .cleaner{
    height: 30px;
    width: 30px;
    background-color:hsl(252, 24%, 95%);
    display: flex;
    align-items: center;
    justify-content: center;
    position: absolute;
    right: -3px;
    top: -3px;
    border-radius: 0 0.375rem 0 0.375rem;
    cursor: pointer;
    -webkit-user-select: none;
    -khtml-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    -o-user-select: none;
    user-select: none;

}

.dark-layout .signature-pad-wrapper .cleaner{
    background-color:hsl(223, 24%, 45%);
}

.dark-layout .signature-pad-wrapper{
    background-color: hsla(252, 24%, 95%) ;
    border: 3px solid hsl(223, 24%, 45%) ;
}

</style>